module.exports = __webpack_public_path__ + "static/media/caret-circle-left.b1a75776.svg";